export enum ProviderType {
  Msp = 0,
  Reseller = 1,
  BusinessUnit = 2,
}
